const theme = {
  // Original colors
  sage: "#8B9D83",
  cream: "#FBF7F0",
  dustyPink: "#DDB9B9",
  pink: "#CC8787FF",
  strongerPink: "#AB7979",
  warmBrown: "#A67B5B",
  lightSage: "#B4C4AE",
  wheat: "#E8DCC4",
  moss: "#6B7F5F",
  blush: "#F4E4E1",
  
  deepMoss: "#4A5A47",
  charcoalBrown: "#3D342A",
  forestGreen: "#4A6741",
  darkSage: "#5F6E5A"
};

export default theme;